const AzureStorageTitle = ({ record }) => {
    return <span>Azure Storage {record ? `"${record.account_name}"` : ''}</span>;
};

export default AzureStorageTitle;